import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core'; 


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})

export class HeaderComponent implements OnInit {
  collapsed = true;

  ngOnInit(): void {
    
  }

  constructor( public translate: TranslateService ) {  
    translate.addLangs(['en', 'ms']); 
    if (localStorage.getItem('locale')) {  
      const browserLang = localStorage.getItem('locale');  
      translate.use(browserLang.match(/en|ms/) ? browserLang : 'en');  

    } else {  
      localStorage.setItem('locale', 'en');  
      translate.setDefaultLang('en'); 
    } 
  }

  changeLang(language: string, elem) { 
    var list = document.querySelectorAll('.language > li > a');
    for(var i=0; i<list.length; i++) {
      list[i].classList.remove('active');
    }
    elem.target.classList.add('active');
    localStorage.setItem('locale', language);  
    this.translate.use(language);  
  }

}